module.exports = __webpack_public_path__ + "static/media/truck-banesco-selected.f58bd38e.svg";